var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    [
      _c("h2", [_vm._v("余额")]),
      _vm._l(_vm.channelBalance, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "yue" },
          [
            _c("h3", [_vm._v(_vm._s(item.bankName))]),
            _vm._l(item.value, function (item1, index1) {
              return _c("div", { key: index1 }, [_vm._v(_vm._s(item1))])
            }),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }